module.exports = "<svg viewBox=\"0 0 299.2 111.4\"><path d=\"M8.1 38.2L0 46.4l16.3 16.2 16.2-16.3-5.5-5.4c3.6-11 13.9-18.5 25.5-18.5V3.5c-21 0-39.3 14.3-44.4 34.7z\" class=\"st0\"></path><path d=\"M105.1 52.1L88.8 35.9 72.6 52.1l5.4 5.4C74.4 68.5 64.1 76 52.5 76v19c21 0 39.3-14.3 44.4-34.7l8.2-8.2z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-environment.svg
// module id = 285
// module chunks = 1